import React, { memo } from "react";
import { Card, Row, Col, OverlayTrigger, Tooltip, Placeholder } from "react-bootstrap";
import { isBoolean } from "@revbox/helpers-fe";
import { auctionCampaignStatusCardLabels } from "@revbox/localization";
import { useCookiesContext } from "../../../contexts/CookiesContext";

const getStatus = (campaign, anyActiveSpecificBid, anyActiveBrandingBid, anyActiveClusterBid, anyActiveEmailsBid, anyActiveContentBid) => {
    const hasAnyActiveBid = anyActiveSpecificBid || anyActiveBrandingBid || anyActiveClusterBid || anyActiveEmailsBid || anyActiveContentBid;
  
    const isActive = campaign?.ppc_active && !campaign?.ppc_paused && hasAnyActiveBid;
    const isNotBidding = campaign?.ppc_active && !hasAnyActiveBid;
    const isInactive = !campaign?.ppc_active && !campaign?.ppc_paused;
    const isPaused = campaign?.ppc_paused;
  
    return { isActive, isNotBidding, isInactive, isPaused };
};

const getStatusInfo = (multilang, statusFlags) => {
    const { isActive, isNotBidding, isInactive, isPaused } = statusFlags;
  
    const map = [
      { condition: isActive, color: "text-success", text: multilang.status.active },
      { condition: isNotBidding, color: "text-warning", text: multilang.status.not_bidding },
      { condition: isInactive, color: "text-danger", text: multilang.status.inactive },
      { condition: isPaused, color: "text-warning", text: multilang.status.paused },
    ];
  
    return map.find((s) => s.condition) || null;
};

const overlayContent = (campaign, multilang) => {
    if (campaign?.ppc_active || campaign?.ppc_paused) {
      return (
        <Tooltip placement="bottom">
          {multilang.tooltip.before} <strong>{multilang.tooltip.highlight}</strong> {multilang.tooltip.after}
        </Tooltip>
      )
    }
    return <></>
}

function DefaultAuctionCampaignStatusCard(props) {
    const { campaign, campaignCategories, anyActiveSpecificBid, anyActiveBrandingBid, anyActiveClusterBid, anyActiveEmailsBid, anyActiveContentBid } = props;

    const { getLanguageAbbr } = useCookiesContext();
    const languageAbbr = getLanguageAbbr();
    const multilang = auctionCampaignStatusCardLabels[languageAbbr];

    if (!isBoolean(anyActiveBrandingBid) && !isBoolean(anyActiveSpecificBid)) {
        return (
            <React.Fragment>
                <Placeholder
                    as={Card.Title}
                    animation="glow"
                    style={{ color: "var(--bs-body-color)" }}
                >
                    <Placeholder style={{ height: 145, width: "100%" }} />
                </Placeholder>
            </React.Fragment>
        );
    }

    const statusFlags = getStatus(campaign, anyActiveSpecificBid, anyActiveBrandingBid, anyActiveClusterBid, anyActiveEmailsBid, anyActiveContentBid);
    const currentStatus = getStatusInfo(multilang, statusFlags);

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={overlayContent(campaign, multilang)}
        >
            <Card className="card-one">
                <Card.Body>
                    <Row>
                        <Col xs="12">
                            {currentStatus && (
                                <h3 className={`card-value fw-bold ${currentStatus.color} mb-0`}>
                                    {currentStatus.text}
                                </h3>
                            )}
                            <label className="card-title fw-medium text-dark mb-1">
                                {multilang.status.label}
                            </label>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer style={{ height: '60px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Row>
                        <Col xs="12">
                            <span className="d-block fs-11 text-secondary lh-4">
                                {multilang.categoriesPrefix}:{" "}
                                {campaignCategories?.length > 2
                                    ? campaignCategories?.slice(0, 2).join(", ") +
                                    ", " +
                                    String(campaignCategories?.length - 2) +
                                    " " + multilang.moreSuffix
                                    : campaignCategories?.join(", ")}
                            </span>
                        </Col>
                    </Row>
                </Card.Footer>
            </Card>
        </OverlayTrigger>
    );
}

export default memo(DefaultAuctionCampaignStatusCard);